export { default } from './TableCell';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/TableCell/index.js
// module id = 374
// module chunks = 121